import EmployeeFunnelsContainer from './EmployeeFunnelsContainer'
import EmployeeLeaderboardContainer from './EmployeeLeaderboardContainer'

/**
 * Page-level FiltersBar state shared by both Performance cards. On the
 * per-recruiter views `recruiters` narrows which rows appear; the other
 * facets narrow which applicants count toward each row.
 */
export interface PerformanceFilters {
  dateRange: { gte: Date; lte: Date }
  recruiters?: string[]
  jobListings?: string[]
  linkTypes?: string[]
  jobTypes?: string[]
}

export interface PerformanceTabProps {
  filters: PerformanceFilters
  refreshKey: number
}

/**
 * Performance tab — Employee leaderboard above, Employee funnels below.
 * Both cards share the page-level filters + refreshKey so a refresh-button
 * click invalidates both queries via the same useEffect signal.
 */
const PerformanceTab = ({ filters, refreshKey }: PerformanceTabProps) => {
  return (
    <div className="flex flex-col gap-4">
      <EmployeeLeaderboardContainer filters={filters} refreshKey={refreshKey} />
      <EmployeeFunnelsContainer filters={filters} refreshKey={refreshKey} />
    </div>
  )
}

export default PerformanceTab
